// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import AdminSidebarController from "./admin_sidebar_controller"
application.register("admin-sidebar", AdminSidebarController)

import AdminTabsController from "./admin_tabs_controller"
application.register("admin-tabs", AdminTabsController)
